/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */
import Vue from 'vue';

export default {
    props: {
        section: {
            type: Object,
            required: true,
        },
        cdnUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isSubtitleTooltipVisible: false,
            selectedModelVersion: null,
            selectedModelType: null,
        };
    },

    components: {
        'cta-builder-component': () => import('./async-cta-builder-component'),
        'model-content-switcher': () =>
            import('./async-model-content-switcher'),
        'model-car-stock-v2': () => import('./async-model-car-stock-v2'),
    },

    mounted() {
        this.findHeroModelContentPicker(
            this.$parent.initialModel.toLowerCase(),
        );

        this.addSubtitleTooltip();
        EventBus.$on('model-version-changed', (versionHandle) => {
            this.addSubtitleTooltip();
        });

        if (!this.selectedModelType) return;

        window.location.hash = this.selectedModelType;
        window.addEventListener('hashchange', this.handleHistoryChange);
    },

    destroyed() {
        window.removeEventListener('hashchange', this.handleHistoryChange);
    },

    methods: {
        handleHistoryChange() {
            const modelVersion = window.location.hash.split('#')[1];
            if (!modelVersion) return;

            const { modelVersionHandle } = this.findHeroModelContentPicker(
                modelVersion,
                'modelVersionName',
            );
            EventBus.$emit('model-version-changed', modelVersionHandle);
        },

        findHeroModelContentPicker(slugToFind, findBy = 'modelVersionHandle') {
            const doesHeroModelContentPickerExists =
                this.section.heroModelContentPicker &&
                this.section.heroModelContentPicker.length > 0;
            if (!doesHeroModelContentPickerExists) return;

            const foundHeroModelContentPicker =
                this.section.heroModelContentPicker.find(
                    (model) => model[findBy].toLowerCase() === slugToFind,
                );

            this.selectedModelVersion =
                foundHeroModelContentPicker.modelVersionHandle;
            this.selectedModelType = this.slugifyModelVersionName(
                foundHeroModelContentPicker.modelVersionName,
            );
            return {
                modelVersionHandle:
                    foundHeroModelContentPicker.modelVersionHandle,

                modelVersionName: foundHeroModelContentPicker.modelVersionName,
            };
        },

        slugifyModelVersionName(modelVersionName) {
            return modelVersionName.replace(/\s+/g, '-').toLowerCase();
        },

        getContentHref(versionHandle) {
            return `#${versionHandle}`;
        },

        changeModelVersion(versionHandle, modelVersionName) {
            const slugifiedModelVersionName =
                this.slugifyModelVersionName(modelVersionName);
            this.selectedModelType = slugifiedModelVersionName;
            window.location.hash = slugifiedModelVersionName;
            this.selectedModelVersion = versionHandle;
            EventBus.$emit('model-version-changed', versionHandle);
        },

        isModelSelected(modelVersionName) {
            const slugifiedModelVersionName =
                this.slugifyModelVersionName(modelVersionName);
            return this.selectedModelType === slugifiedModelVersionName
                ? 'new-model-hero__link--selected'
                : '';
        },

        toggleSubtitleTooltip() {
            this.isSubtitleTooltipVisible = !this.isSubtitleTooltipVisible;

            const tooltip = this.$el.querySelector(
                '.model-header__toolbar-subtitle',
            );
            if (!tooltip) return;

            tooltip.classList.toggle(
                'model-header__toolbar-text--active',
                this.isSubtitleTooltipVisible,
            );
        },

        addSubtitleTooltip() {
            setTimeout(() => {
                this.isSubtitleTooltipVisible = false;

                const subtitle = this.$el.querySelector(
                    '.new-model-hero__subtitle > h2:last-of-type',
                );
                if (!subtitle || !this.section.headerSubtitleToolbarText)
                    return;

                subtitle.style.position = 'relative';

                const src = this.cdnUrl + '/images/tooltip.svg';

                if (
                    subtitle.innerHTML.includes('model-header__tooltip-wrapper')
                )
                    return;

                subtitle.innerHTML += `
                        <span class="model-header__tooltip-wrapper model-header__tooltip-wrapper__new-model model-header__subtitle-wrapper"
                        style="margin:0px;display:inline-flex;"
                        >
                            <img src="${src}"
                                class="carshowcase__content-tooltip"
                                alt="Tooltip" />
                            <span class="model-header__toolbar-text model-header__toolbar-text__new-model model-header__toolbar-subtitle"
                            >
                                ${this.section.headerSubtitleToolbarText}
                            </span>
                        </span>
                    `;

                subtitle
                    .querySelector('.carshowcase__content-tooltip')
                    .addEventListener('click', this.toggleSubtitleTooltip);
            }, 300);
        },
    },
};
